import { render } from "./CurrentPointTable.vue?vue&type=template&id=18b230c9&scoped=true"
import script from "./CurrentPointTable.vue?vue&type=script&lang=js"
export * from "./CurrentPointTable.vue?vue&type=script&lang=js"

import "./CurrentPointTable.vue?vue&type=style&index=0&id=18b230c9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b230c9"]])

export default __exports__